import React from 'react';
import { ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid, ReferenceLine, ResponsiveContainer } from 'recharts';
import { formatCurrency, formatDateBR } from '../../../core/utils/format';
import { CHART_COLORS } from '../../../core/constants/financial';

// Barras de entradas/saídas + linha de saldo acumulado. Compartilhado entre o
// modal de Fluxo Projetado e o painel do dashboard.
const ProjectedCashFlowChart = ({ data, height = 340 }) => (
  <ResponsiveContainer width="100%" height={height}>
    <ComposedChart data={data} margin={{ top: 16, right: 24, left: 8, bottom: 8 }}>
      <CartesianGrid strokeDasharray="3 3" stroke={CHART_COLORS.grid} vertical={false} />
      <XAxis
        dataKey="date"
        tick={{ fontSize: 10, fill: CHART_COLORS.tick }}
        tickFormatter={(v) => {
          const [, m, d] = v.split('-');
          return `${d}/${m}`;
        }}
        axisLine={{ stroke: CHART_COLORS.axis }}
        tickLine={{ stroke: CHART_COLORS.axis }}
        minTickGap={20}
      />
      <YAxis
        tick={{ fontSize: 10, fill: CHART_COLORS.tick }}
        tickFormatter={(v) => {
          if (Math.abs(v) >= 1000) return `R$${(v / 1000).toFixed(0)}k`;
          return `R$${v}`;
        }}
        axisLine={{ stroke: CHART_COLORS.axis }}
        tickLine={{ stroke: CHART_COLORS.axis }}
        width={56}
      />
      <ReferenceLine y={0} stroke="#666" strokeDasharray="2 2" />
      <Tooltip
        formatter={(value, name) => [formatCurrency(value), name]}
        labelFormatter={(label) => formatDateBR(label)}
        contentStyle={{
          background: CHART_COLORS.tooltipBg,
          border: `1px solid ${CHART_COLORS.axis}`,
          borderRadius: 6,
          fontSize: 11,
          padding: '8px 10px',
        }}
        cursor={{ fill: 'rgba(255,255,255,0.04)' }}
      />
      <Legend wrapperStyle={{ fontSize: 11, paddingTop: 8 }} iconType="circle" />
      <Bar dataKey="entradas" name="Entradas" fill={CHART_COLORS.green} radius={[2, 2, 0, 0]} />
      <Bar dataKey="saidas" name="Saídas" fill={CHART_COLORS.orange} radius={[2, 2, 0, 0]} />
      <Line
        type="monotone"
        dataKey="saldoAcumulado"
        name="Saldo Acumulado"
        stroke={CHART_COLORS.blue}
        strokeWidth={2.5}
        dot={false}
        activeDot={{ r: 4, fill: CHART_COLORS.blue, stroke: '#fff', strokeWidth: 1 }}
      />
    </ComposedChart>
  </ResponsiveContainer>
);

export default ProjectedCashFlowChart;
